import * as Types from '../../../graphql.generated';

export type UpdateUserAboutMeMutationVariables = Types.Exact<{
    input: Types.UserAboutMeInput;
}>;

export type UpdateUserAboutMeMutation = { __typename?: 'Mutation' } & Pick<
    Types.Mutation,
    'updateUserAboutMe'
>;

export const UpdateUserAboutMeDocument = `
    mutation updateUserAboutMe($input: UserAboutMeInput!) {
  updateUserAboutMe(input: $input)
}
    `;
export type Requester<C = {}> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C>(requester: Requester<C>) {
    return {
        updateUserAboutMe(
            variables: UpdateUserAboutMeMutationVariables,
            options?: C
        ): Promise<UpdateUserAboutMeMutation> {
            return requester<
                UpdateUserAboutMeMutation,
                UpdateUserAboutMeMutationVariables
            >(UpdateUserAboutMeDocument, variables, options);
        }
    };
}
export type Sdk = ReturnType<typeof getSdk>;
